import SchoolAssociations from './SchoolAssociations.page';

export default SchoolAssociations;